<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateSeparationType"
        class="bg-black fixed bg-opacity-70 inset-0 z-50  w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed   center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Create Separation Type</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              alt=""
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Name</label>
              <input
                v-model="info.Name"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full capitalize"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Description</label>
              <textarea
                name=""
                id=""
                cols="30"
                rows="5"
                class="p-2 bg-gray-200 rounded-md w-full"
                v-model="info.Description"
                min="0"
                required
              ></textarea>
            </div>

            <div class="mb-1">
              <label class="block text-sm mb-2" for="consecutive-switch">
                File Attachment
              </label>
              <div class="flex items-center bg-gray-200 rounded-md p-2">
                <input
                  id="consecutive-switch"
                  type="checkbox"
                  class="cursor-pointer form-checkbox h-5 w-5 text-blue-600"
                  v-model="info.AttachmentRequired"
                />
                <label for="consecutive-switch" class="ml-2 block text-sm">
                  Requires File
                </label>
              </div>
            </div>
            <div class="">
              <label class="block text-sm mb-2" for="consecutive-switch">
                Employee Initiation
              </label>
              <div class="flex items-center bg-gray-200 rounded-md p-2">
                <input
                  id="consecutive-switch"
                  type="checkbox"
                  class="cursor-pointer form-checkbox h-5 w-5 text-blue-600"
                  v-model="info.EmployeeInitiate"
                />
                <label for="consecutive-switch" class="ml-2 block text-sm">
                  Employee Can Initiate
                </label>
              </div>
            </div>

            <div class="mb-1">
              <div class="flex items-center bg-gray-200 rounded-md p-2">
                <input
                  id="policy-days-switch"
                  type="checkbox"
                  class="cursor-pointer form-checkbox h-5 w-5 text-blue-600"
                  v-model="info.PolicyDaysRequired"
                />
                <label for="policy-days-switch" class="ml-2 block text-sm">
                  Requires Policy Days
                </label>
              </div>
            </div>

            <div class="mb-1" v-if="info.PolicyDaysRequired">
              <label class="block text-sm mb-2" for="policy-days">
                Policy Days
              </label>

              <input
                id="policy-days"
                type="number"
                class="p-2 bg-gray-200 rounded-full w-full capitalize"
                v-model="info.PolicyDays"
              />
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
// import Switches from 'vue-switches';

export default {
  name: "CompanySetupCreateSeparationTypes",
  props: ["showCreateSeparationType"],
  components: { Loader },
  data() {
    return {
      create_error: null,
      loading: false,
      create_success: null,
      info: {
        Name: "",
        Description: "",
        AttachmentRequired: false,
        EmployeeInitiate: false,
        PolicyDaysRequired: false,
        PolicyDays: 0,
      },
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    getFile({ target }) {
      const file = target.files[0];
      this.info.File = file;
      const blob = new Blob([file], { type: "*" });

      // Create a URL for the Blob
      this.preview = URL.createObjectURL(blob);
    },
    close() {
      this.$emit("close");
    },
    created() {
      this.loading = true;
    },
    create() {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      this.info.EarnedPerMonth = parseFloat(this.info.EarnedPerMonth);
      axios
        .post(
          `${this.getOrganization}/setup/separation/type/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.info = {
                Name: "",
                Description: "",
                AttachmentRequired: false,
              };
              this.create_success = response.data.StatusMessage;
              setTimeout(() => {
                this.create_success = null;
                this.$emit("closeOnSuccess");
              }, 2000);
            } else {
              this.create_error = response.data.StatusMessage;
              setTimeout(() => {
                this.create_error = null;
              }, 2000);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            setTimeout(() => {
              this.create_error = null;
            }, 2000);
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.slider.thumb-yellow {
  background-color: yellow;
}

.slider.thumb-yellow {
  background-color: yellow;
}

.slider.thumb-yellow {
  background-color: yellow;
}
</style>
